<template>
<div>
    <smallbutton :toplabel="buttonText" @click="Show()" v-if="showButton" :disabled="disabled" :buttonclass="buttonclass"/>
    <linkbutton :toplabel="buttonText" @click="Show()" v-if="showLink" :disabled="disabled"/>
    <removebutton @click="Show()" v-if="showImageButton" :disabled="disabled"/>

    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <label class="titlelabel">{{title}}</label>
            <label :class="textclass">{{body}}</label>
            <div>
                <smallbutton buttonclass="buttonwide buttonprimary"  @click="CloseWithDocuments" toplabel="Add Documents" />
                <smallbutton buttonclass="buttonwide buttonprimary" @click="CloseWithPayment" toplabel="Make A Payment" />
                <smallbutton buttonclass="buttonwide buttonprimary" @click="CloseWithNotMe" toplabel="Not Me" v-if="allowSave"/>
                <smallbutton buttonclass="buttonwide buttonprimary" @click="CloseWithCancel" toplabel="Cancel" v-if="!allowSave"/>
            </div>
            <div>
              <label class="responsemessage">{{responseMessage}}</label>
            </div>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import smallbutton from '../controls/button.vue'
import actionmodal from '../actions/actionmodal.vue'
import linkbutton from '../controls/linkbutton.vue'
import removebutton from '../controls/removebutton.vue'

export default {
    name:'confirm',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,
        removebutton
    },
    props:{
        buttonLabel:{
            type:String,
            default:""
        },
        title:{
            type:String,
            required:true
        },
        body:{
            type:String,
        },
        showButton:{
            type:Boolean,
            default:false
        },
        showImageButton:{
            type:Boolean,
            default:false,
        },
        showLink:{
            type:Boolean,
            default:false
        },
        disabled:{
          type:Boolean,
          default:false
        },
        buttonclass:{
            type:String,
            default:"button primarybutton"
        },
        redText:{
            type:Boolean,
            default:false,
        },
        greenText:{
            type:Boolean,
            default:false,
        },
        noLabel:{
            type:String,
            default:'No'
        }
    },
    data(){
        return{
            responseMessage:'',

        }
    },
    computed:{
        buttonText(){
            if (this.buttonLabel==""){return this.title}
            else{return this.buttonLabel}
        },
        textclass(){
            if(this.redText){return "responsemessage multilinelabel"}
            else if(this.greenText){return "greentext multilinelabel"}
            else{return ""}
        },
        allowSave(){
            return this.body.includes('Not Me')
        }
    },
    methods:{
        
        Show(){
    
            this.$refs.mymodal.openModal()
        },
        async CloseWithDocuments(){
            this.$emit('documents')
            this.$refs.mymodal.closeModal()
        },
        async CloseWithPayment(){
            this.$emit('payment')
            this.$refs.mymodal.closeModal()
        },
        async CloseWithNotMe(){
            this.$emit('notme')
            this.$refs.mymodal.closeModal()
        },
        async CloseWithCancel(){
            this.$emit('cancel')
            this.$refs.mymodal.closeModal()
        },
    }
}
</script>

<style>
.greentext{
    color:green;
    font-size:large;
}
   .multilinelabel{
  white-space: pre-wrap;
  max-width:100%;
  text-align:left;
  
}
.buttonwide{
    
    color:var(--light-text-color);
    border: none;
    border-radius:10px;
    width:140px;
    height:50px;
    padding:0px;
    font-size: medium;
    margin:10px;
  text-decoration: none;
}
</style>